import { lowerUserAgent } from "./shared.js";
const webkit = typeof CSS !== "undefined" && !!CSS.supports?.("-webkit-backdrop-filter:none");
!webkit && lowerUserAgent.includes("firefox");
!webkit && lowerUserAgent.includes("chrom");
export {
  webkit
};
//# sourceMappingURL=engine.js.map
